import Button from './components/Button/index';
import Title from './components/Title/index';
import HeaderContainer from './components/HeaderContainer/index';
import FooterContainer from './components/FooterContainer/index';
import Select from './components/Select/index';
import SelectGroup from './components/SelectGroup/index';
import Input from './components/Input/index';
import Add from './components/Add/index';
import Mark from './components/Mark/index';
import SupportReplyInput from './components/SupportReplyInput/index';
import Icon from './components/Icon/index';
import List from './components/List/index';
import ListItem from './components/ListItem/index';
import ThirPartPay from './components/ThirPartPay/index';
import InnerPay from './components/InnerPay/index';
import SelectTriggerBtn from './components/SelectTriggerBtn/index';
import Block from './components/Block/index';
import PayState from './components/PayState/index';
import SwitchAccount from './components/SwitchAccount/index';
import BindAccount from './components/BindAccount/index';
import Content from './components/Content/index';
import Editor from './components/Editor/index';
import BlockClickable from './components/BlockClickable/index';
import PopupWindow from './components/PopupWindow/index';
import ScoreStart from './components/ScoreStart/index';
import LoaddingPage from './components/LoaddingPage/index';
import VLink from './components/VLink/index';
import StoreLogo from './components/StoreLogo/index';

const COMMON_CLASS_PREFIX = '.ocean-ui';

export default {
  install(Vue, options) {
    let styles = createStyles('', COMMON_CLASS_PREFIX, options.commonStyles);
    let landscapeStyle = createStyles(
      '',
      COMMON_CLASS_PREFIX,
      options.landscapeStyle || {}
    );
    let portraitStyles = createStyles(
      '',
      COMMON_CLASS_PREFIX,
      options.portraitStyles || {}
    );
    appendStyles(styles);
    if (landscapeStyle) {
      appendStyles(`
      @media screen and (orientation: landscape) {
        ${landscapeStyle}
      }
      `);
    }
    if (portraitStyles) {
      appendStyles(`
      @media screen and (orientation: portrait) {
        ${portraitStyles}
      }
      `);
    }
    Vue.component('Button', Button.getComponentByConfig(options));
    Vue.component('ScoreStart', ScoreStart.getComponentByConfig(options));
    Vue.component('Title', Title.getComponentByConfig(options));
    Vue.component('Select', Select.getComponentByConfig(options));
    Vue.component('SelectGroup', SelectGroup.getComponentByConfig(options));
    Vue.component('InputComp', Input.getComponentByConfig(options));
    Vue.component(
      'HeaderContainer',
      HeaderContainer.getComponentByConfig(options)
    );
    Vue.component(
      'FooterContainer',
      FooterContainer.getComponentByConfig(options)
    );
    Vue.component(
      'SupportReplyInput',
      SupportReplyInput.getComponentByConfig(options)
    );
    Vue.component('Add', Add.getComponentByConfig(options));
    Vue.component('Mark', Mark.getComponentByConfig(options));
    Vue.component('Icon', Icon.getComponentByConfig(options));
    Vue.component('List', List.getComponentByConfig(options));
    Vue.component('ListItem', ListItem.getComponentByConfig(options));
    Vue.component('ThirPartPay', ThirPartPay.getComponentByConfig(options));
    Vue.component('InnerPay', InnerPay.getComponentByConfig(options));
    Vue.component(
      'SelectTriggerBtn',
      SelectTriggerBtn.getComponentByConfig(options)
    );
    Vue.component('Block', Block.getComponentByConfig(options));
    Vue.component('PayState', PayState.getComponentByConfig(options));
    Vue.component('BindAccount', BindAccount.getComponentByConfig(options));
    Vue.component('SwitchAccount', SwitchAccount.getComponentByConfig(options));
    Vue.component('Content', Content.getComponentByConfig(options));
    Vue.component('Editor', Editor.getComponentByConfig(options));
    Vue.component(
      'BlockClickable',
      BlockClickable.getComponentByConfig(options)
    );
    Vue.component('PopupWindow', PopupWindow.getComponentByConfig(options));
    Vue.component('LoaddingPage', LoaddingPage.getComponentByConfig(options));
    Vue.component('VLink', VLink.getComponentByConfig(options));
    Vue.component('StoreLogo', StoreLogo.getComponentByConfig(options));
  },
};

let createStyles = function (styles, prefix, options) {
  let classNames = Object.keys(options || {});
  for (let i = 0, len = classNames.length; i < len; i++) {
    let name = classNames[i];
    if (options[name] && options[name].commonTheme) {
      styles = appendStylesTosClass(
        styles,
        prefix + '-' + name,
        options[name].commonTheme
      );
    }
    if (options[name] && options[name].typeTheme) {
      styles = createStyles(
        styles,
        prefix + '-' + name,
        options[name].typeTheme
      );
    }
    if (
      options[name] &&
      !options[name].typeTheme &&
      !options[name].commonTheme
    ) {
      styles = appendStylesTosClass(styles, prefix + '-' + name, options[name]);
    }
  }
  return styles;
};

let appendStylesTosClass = function (styles, classNAme, options) {
  let stylesNames = Object.keys(options || {});
  let curStyle = '';
  for (let i = 0, len = stylesNames.length; i < len; i++) {
    let name = stylesNames[i];
    let styleValue = options[name];
    styleValue = styleValue.replace('!important', '');
    curStyle +=
      '  ' + name + ':' + styleValue.replace(/\;\s*$/, '') + ' !important;\n';
  }
  if (curStyle !== '') {
    styles += `${classNAme} {\n${curStyle}}\n`;
  }
  return styles;
};

let appendStyles = function (styles) {
  let head = document.head || document.getElementsByTagName('head')[0];
  let style = document.createElement('style');

  head.appendChild(style);

  style.type = 'text/css';
  if (style.styleSheet) {
    // This is required for IE8 and below.
    style.styleSheet.cssText = styles;
  } else {
    style.appendChild(document.createTextNode(styles));
  }
};
